import { of } from 'rxjs';
import {
	ICoreRoutes,
	IPageMetadata,
	ITypeRoute,
	ITypeRouteAction,
	RouteInitializer
} from '../../pages/type-routes/type-route.models.js';
import { ListLogsComponent } from '../../modules/logs/list-logs.component.js';
import { ListBackkgroundLogsComponent } from 'src/app/modules/background-logs/list-background-logs.component.js';
import { ListEmailsComponent } from 'src/app/modules/logs/list-emails.component.js';

export interface IAdminLogRoutes extends ICoreRoutes {
	logs: ITypeRoute<
		undefined,
		{
			listLogs: ITypeRouteAction<undefined>;
		}
	>;
	emails: ITypeRoute<
		undefined,
		{
			listEmails: ITypeRouteAction<undefined>;
		}
	>;
	backgroundTaskLogs: ITypeRoute<
		undefined,
		{
			overview: ITypeRouteAction<undefined>;
		}
	>;
}

export const adminLogRoutes: RouteInitializer<IAdminLogRoutes> = {
	logs: {
		mainPath: 'admin',
		uniqueId: 'logs',
		parentRoutes: (context) => [],
		loadSharedData: (context) => {
			return of(undefined);
		},
		menuItems: (context) => [],
		children: {
			listLogs: {
				uniqueId: `listLogs`,
				component: ListLogsComponent,
				getMetadata: (data) => {
					const metadata: IPageMetadata = {
						title: `Logs`
					};
					return metadata;
				}
			}
		}
	},
	emails: {
		mainPath: 'admin',
		uniqueId: 'emails',
		parentRoutes: (context) => [],
		loadSharedData: (context) => {
			return of(undefined);
		},
		menuItems: (context) => [],
		children: {
			listEmails: {
				uniqueId: `listEmails`,
				component: ListEmailsComponent,
				getMetadata: (data) => {
					const metadata: IPageMetadata = {
						title: `Emails`
					};
					return metadata;
				}
			}
		}
	},
	backgroundTaskLogs: {
		mainPath: 'admin',
		uniqueId: 'backgroundLogs',
		parentRoutes: (context) => [],
		loadSharedData: (context) => {
			return of(undefined);
		},
		menuItems: (context) => [],
		children: {
			overview: {
				uniqueId: `backgroundTaskogsOverview`,
				component: ListBackkgroundLogsComponent,
				getMetadata: (data) => {
					const metadata: IPageMetadata = {
						title: `Background task logs`
					};
					return metadata;
				}
			}
		}
	}
};
